import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

// import brandDesign from '../assets/images/pic09.jpg'
// import digitalReality from '../assets/images/digital-reality.jpg'

const About = (props) => (
    <div>
        <Helmet>
            <title>IMBIBE - About our brand design firm</title>
            <meta name="description" content="Generic Page" />
        </Helmet>

        <div id="main">
            <section id="one">
                <div className="inner">
                    <h1>About Us</h1>
                    <p><em>We are creative partners for leaders who aspire to distinction among their peers</em>. As a team of strategists, creatives and technologists, we approach business challenges thoughtfully and aim to design extraordinary brand experiences across all touch-points.</p>
                    <p><em>No brand exists in a vacuum</em> &mdash; they’re one part of a complex ecosystem of influences. We offer a deep understanding of the social/cultural/economic contexts in which brands exist, building solutions that fit beautifully within &mdash; and oftentimes challenge the context.</p>
                </div>
            </section>
        </div>

    </div>
)

export default About


// WEBPACK FOOTER //
// ./src/pages/about-us.js